import React from 'react';
import {
  Hash,
  MapPin,
  Phone,
  User,
} from '@phosphor-icons/react';

function ClientRow({ icon: Icon, label, value }) {
  if (!value) {
    return null;
  }

  return (
    <div className="flex items-start gap-3 border-t border-line/80 py-3 first:border-t-0 first:pt-0">
      <div className="mt-1 text-content-muted">
        <Icon size={18} />
      </div>
      <div>
        <p className="text-sm text-content-muted">{label}</p>
        <p className="text-base font-medium text-content">{value}</p>
      </div>
    </div>
  );
}

function TaskClientInfoCard({ client }) {
  return (
    <aside className="rounded-3xl border border-line bg-surface/80 p-6 shadow-lg shadow-black/10">
      <div className="mb-5 flex items-center gap-3">
        <div className="rounded-xl bg-surface-2 p-2 text-content-muted">
          <User size={20} />
        </div>
        <h2 className="text-lg font-semibold text-content">Información del cliente</h2>
      </div>

      <div className="mb-5 flex items-center gap-4 rounded-2xl bg-bg/40 p-4">
        <div>
          <p className="text-xl font-semibold text-content">{client?.name || 'Cliente sin nombre'}</p>
        </div>
      </div>

      <ClientRow icon={Phone} label="Teléfono" value={client?.phone} />
      <ClientRow icon={Phone} label="Tel. secundario" value={client?.secondaryPhone} />
      <ClientRow icon={Hash} label="CUIL/CUIT" value={client?.cuil || client?.cuit} />
      <ClientRow icon={MapPin} label="Dirección" value={client?.address} />
    </aside>
  );
}

export default TaskClientInfoCard;
